import styles from "./Instalment.module.scss";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import AmenitySection from "../AmenitiesSection/components/AmenitySection";
import CustomAccordionItem from "./components/CustomAccordianItem";
import AccordionV2 from "@Components/Accordian";
import PropertyDetailsModal from "../PropertyDetailsModal";
import CustomModeOfPayment from "./components/CustomModeOfPayment";
import InstalmentFilterGroup from "./components/InstalmentFilterGroup";
import { getInstallmentPlansByGuarantorType } from "./utils";
import TabSection from "./components/InstalmentTabSection";
import wrapperHOC from "@Utils/wrapperHOC";
import Button from "@Components/Button";
import BillsIncludedModal from "../AmenitiesSection/components/BillsIncludedModal";
import {
  getPricingCurrency,
  getPricingDuration,
} from "@Pages/PropertyPage/components/RoomTypeSection/utils";
import { useSelector, shallowEqual } from "react-redux";
import { AppState } from "@Store/index";
import config from "@Config/index";
//

interface DesktopInstalmentSectionProps {
  filteredData: any[];
  sortedData: any[];
  showModal: boolean;
  handleModalClose: () => void;
  selectedDuration: string;
  setSelectedDuration: (duration: string) => void;
  selectedYear: string;
  setSelectedYear: (year: string) => void;
  filtersData: {
    duration: string[];
    year: string[];
  };
  installmentPlans: any[];
  isModal: boolean;
  tabdata: any;
  setActiveTab: any;
  activeTab: any;
  isDesktop: boolean;
  hasInstallmentPlans?: boolean;
  t: (key: string | any, str?: string | any, _value?: string | any) => any;
  handleBillsModalOpen: () => void;
  handleBillsModalClose: () => void;
  showBillsModal: boolean;
  prefixContent: any;
  suffixContent: any;
  amenities: any[];
  totalCalculatedPrice: number;
  allAmenitiesHaveNAPrices: boolean;
  hasEstimatedItems: boolean;
}

const DesktopInstalmentSection = ({
  filteredData,
  sortedData,
  showModal,
  handleModalClose,
  selectedDuration,
  setSelectedDuration,
  selectedYear,
  setSelectedYear,
  filtersData,
  installmentPlans,
  isModal,
  tabdata,
  setActiveTab,
  activeTab,
  isDesktop,
  hasInstallmentPlans = false,
  t,
  handleBillsModalOpen,
  handleBillsModalClose,
  showBillsModal,
  prefixContent,
  suffixContent,
  amenities = [],
  totalCalculatedPrice = 0,
  allAmenitiesHaveNAPrices = false,
  hasEstimatedItems = false,
}: DesktopInstalmentSectionProps) => {
  const { inventoryCurrency, inventoryLocation, inventoryPricingDuration } = useSelector(
    ({ propertyPageData }: AppState) => ({
      inventoryCurrency: propertyPageData?.data?.pricing?.currency,
      inventoryLocation:
        propertyPageData?.data?.region?.name ||
        propertyPageData?.data?.region?.city ||
        propertyPageData?.data?.region?.combined_name ||
        t("this location"),
      inventoryPricingDuration: propertyPageData?.data?.pricing?.duration,
    }),
    shallowEqual,
  );

  const currencySymbol = getPricingCurrency(inventoryCurrency) || "£";
  const pricingPeriod = getPricingDuration(inventoryPricingDuration) || t("week");

  const formatTotalPrice = (price: number) => {
    const numPrice = Number(price);
    const roundedPrice = Math.round(numPrice);
    const isRounded = numPrice !== roundedPrice;
    return { price: roundedPrice, isRounded };
  };
  const getConstantChineseTranslation = () =>
    `${t("propertypage.instalmentsection.estimatedsavingsstring")} ${inventoryLocation})`;

  const { price: totalPrice, isRounded } = formatTotalPrice(totalCalculatedPrice);
  const tilde = isRounded ? "~" : "";

  const formattedTotalPrice = hasEstimatedItems
    ? `${tilde}${currencySymbol}${totalPrice}+/${pricingPeriod}`
    : `${tilde}${currencySymbol}${totalPrice}/${pricingPeriod}`;

  return (
    <>
      {/* <div
        className={formatClassNames(styles.amenitiesContainerOuter, styles.desktop)}
        id="rent_instalments"
      > */}
      {/* {!isModal && (
          <>
            <div
              data-testid="property-amenities"
              className={formatClassNames(styles.amenitiesTitle, styles.desktop)}
            >
              {hasInstallmentPlans
                ? t("propertypage.instalmentsection.billsandpaymentsstring")
                : t("propertypage.instalmentsection.billsandpaymentsstring")}
            </div>
            {filteredData && filteredData.length > 0 && <div className={styles.divider} />}
          </>
        )} */}
      <div className={styles.amenitiesContainerInner}>
        {filteredData?.map((feature: any, idx: number) => (
          <>
            {!(
              feature?.name === "Bills Included" &&
              (!feature?.values || feature?.values?.length === 0)
            ) && (
              <AmenitySection
                dataTestId="property-amentities"
                title={feature.name}
                amenityList={feature?.values}
                withDivider={idx < filteredData?.length - 1}
                key={feature.name}
                isDesktop
                amenitiesImages={[]}
              />
            )}
          </>
        ))}
        {!allAmenitiesHaveNAPrices && (
          <>
            <div className={styles.totalSection}>
              <div className={styles.totalLabel}>{getConstantChineseTranslation()}</div>
              <div className={styles.totalAmount}>
                <span className={styles.totalPrice}>{formattedTotalPrice}</span>
                <span className={styles.freeTag}>{t("propertypage.instalmentsection.free")}</span>
              </div>
            </div>
            <div className={styles.divider} />
            <Button
              dataTestId="property-view-all-amenities"
              variant="showAll"
              onClick={handleBillsModalOpen}
            >
              {t("propertypage.instalmentsection.viewsavingsbreakdownstring")}
            </Button>
          </>
        )}
      </div>
      {/* </div> */}
      {showBillsModal && (
        <PropertyDetailsModal
          header={t("propertypage.instalmentsection.billsincludedstring")}
          actionButtonText={t("propertypage.instalmentsection.gotitstring")}
          hidePropertyModal={handleBillsModalClose}
          isDesktop={isDesktop}
        >
          {prefixContent && <>{prefixContent}</>}
          <>
            <BillsIncludedModal
              amenities={amenities.length > 0 ? amenities : []}
              totalWeeklyCost={totalCalculatedPrice || 80}
              isDesktop={isDesktop}
            />
          </>
          {suffixContent && <>{suffixContent}</>}
        </PropertyDetailsModal>
      )}

      {(hasInstallmentPlans || config.IS_CHINA_APP) && (
        <>
          <div className={styles.innerSeprator} />
          <div
            className={formatClassNames(styles.amenitiesContainerOuter, styles.desktop)}
            id="rent_instalments"
          >
            {/* <div className={styles.divider} /> */}
            <div className={formatClassNames(styles.amenitiesSubTitle)}>
              {t("propertypage.instalmentsection.instalmentplanstring")}
            </div>
            <div className={styles.divider} />

            <div className={formatClassNames(styles.amenitiesSubTitle)}>
              <InstalmentFilterGroup
                filtersData={filtersData}
                setDuration={(duration) => setSelectedDuration(duration)}
                setYear={(year) => setSelectedYear(year)}
                // installmentPlans={installmentPlans}
              />
            </div>
            <div className={styles.divider} />

            <TabSection
              tabdata={tabdata}
              setActiveTab={setActiveTab}
              activeTab={activeTab}
              isDesktop={isDesktop}
            />
          </div>
        </>
      )}

      {isModal && <div className={styles.margintop} />}

      {showModal && (
        <PropertyDetailsModal
          header={t("propertypage.instalmentsection.amenitiesstring")}
          hidePropertyModal={handleModalClose}
          isDesktop
          bodyWithNoPadding
        >
          <div className={styles.amenitiesContainerOuter}>
            <div className={styles.amenitiesContainerInner}>
              {sortedData.map((feature: any, idx: number) => (
                <AmenitySection
                  dataTestId="property-amentities-modal"
                  title={feature.name}
                  amenityList={feature.values}
                  withDivider={idx < sortedData.length - 1}
                  isDesktop
                  amenitiesImages={[]}
                  modalView
                  showAll
                />
              ))}
            </div>
          </div>
        </PropertyDetailsModal>
      )}

      {(hasInstallmentPlans || config.IS_CHINA_APP) && (
        <>
          <div className={styles.innerSeprator} />
          <AccordionV2
            data={getInstallmentPlansByGuarantorType(
              installmentPlans,
              selectedDuration,
              selectedYear,
              activeTab,
              t,
            )}
            CustomAccordionItem={CustomAccordionItem}
            isDesktop
            sectionClassname={formatClassNames(
              styles.sectionV2,
              styles.desktop,
              isModal && styles.sectionV2Modal,
            )}
          />
          {isModal && <div className={styles.margintop} />}
          <div className={styles.innerSeprator} />
          <div className={styles.accordionWrapper}>
            <div className={styles.noteContainer}>
              <span className={styles.noteLabel}>
                {t("propertypage.instalmentsection.notestring")}:{" "}
              </span>
              <span className={styles.noteText}>
                {t("propertypage.instalmentsection.illustrationnotestring")}
              </span>
            </div>
          </div>

          {isModal && <div className={styles.margintop} />}
        </>
      )}
      <div className={styles.innerSeprator} />
      <CustomModeOfPayment />
    </>
  );
};

export default wrapperHOC(DesktopInstalmentSection, {
  componentName: "DesktopInstalmentSection-InstalmentSection-PropertyPage",
  showForChina: true,
});
